// extracted by mini-css-extract-plugin
export var chevron = "_mx-3";
export var chevronRotated = "_mx-4";
export var image = "_mx-1";
export var imageContainer = "_mx-0";
export var shippingAddress = "_mx-2";